import type { FunctionComponent } from 'react';

import { Button } from '~/ui/core/button/Button';
import { AISparklesIcon } from '~/ui/core/icons';

import { useChatStore } from '../../chat';

export const AgentButton: FunctionComponent<{
    readonly label: string;
    readonly size?: 'sm';
}> = ({ label, size }) => {
    const openChat = useChatStore((state) => state.open);

    return (
        <Button iconPosition="leading" size={size} variant="secondary" onClick={openChat}>
            <AISparklesIcon />
            {label}
        </Button>
    );
};
